import React, { PureComponent } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { Paper, PaperProps } from '@mui/material';

interface Props extends PaperProps {
    loading?: boolean;
    style?: React.CSSProperties;
    elevation?: number;
}
export default class RaisedPage extends PureComponent<Props> {
    render() {
        const { children, elevation, loading, style, ...rest } = this.props;
        if (loading) {
            return (
                <div style={{ textAlign: 'center', padding: '5rem' }}>
                    <CircularProgress />
                </div>
            );
        } else {
            return (
                <Paper
                    elevation={elevation ? elevation : 4}
                    style={style}
                    sx={{
                        margin: 2,
                        display: 'flex',
                        minHeight: '97vh', // TODO: iron this out in a smarter way with flex
                        padding: 0,
                    }}
                    {...rest}
                >
                    {children}
                </Paper>
            );
        }
    }
}
